import advisePanda from "../../assets/images/Panda/advisePanda.png";
import ResponsiveImage from "../common/ResponsiveImage";

const SectionBannerContact = () => {
  return (
    <section className="relative overflow-hidden bg-[linear-gradient(180deg,#fff_0%,#fff5f5_100%)]">
      <div className="container mx-auto flex min-h-[420px] flex-col items-center justify-center px-4 py-8 sm:px-6 md:flex-row md:px-[40px] lg:h-[500px] lg:gap-16 lg:py-0 xl:gap-20">
        <div className="order-1 mt-8 w-full md:order-1 lg:mt-0 lg:w-[46%]">
          <div className="welcome-meter">
            <div className="relative flex h-[240px] items-center justify-center sm:h-[300px] md:h-[380px] lg:h-[500px]">
              <ResponsiveImage
                className="gt-transparency-anim-bg contact-banner-visual h-auto max-w-[88%] lg:max-w-[82%]"
                src={advisePanda}
                alt="Contact Panda"
              />
            </div>
          </div>
        </div>

        <div className="order-2 mb-8 mt-5 w-full text-left sm:mt-0 md:pb-10 md:pt-16 lg:order-2 lg:mb-0 lg:w-[54%]">
          <span className="inline-flex items-center rounded-full border border-red-500/20 bg-red-50 px-4 py-2 text-[11px] font-medium uppercase tracking-[0.16em] text-red-700">
            Kết nối giải pháp
          </span>

          <h1 className="mt-5 max-w-[680px] text-[28px] font-semibold leading-[1.14] text-[#2f1a1a] mobile598:text-[33px] md:text-[30px] lg:text-[42px]">
            Liên Hệ Với TrioCore Solutions
          </h1>

          <p className="mt-5 max-w-[680px] text-[14px] leading-8 text-slate-600 mobile598:text-[15px] lg:text-[16px]">
            Đội ngũ chuyên gia của chúng tôi sẵn sàng lắng nghe bài toán kinh doanh của bạn, từ đó tư
            vấn và đo lường những giải pháp số toàn diện: Web/App cao cấp, Phần mềm quản trị (CRM/ERP)
            hay Chiến dịch Digital Marketing tối ưu.
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:gap-4">
            <button className="button-secondary w-full sm:w-auto">0822041909</button>
            <a href="#contact-section" className="w-full sm:w-auto">
              <button className="button-primary w-full sm:w-auto">Gửi yêu cầu tư vấn</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionBannerContact;
